type Props = {
  img: string;
  title: string;
};

export function SectionTitle({ img, title }: Props) {
  return (
    <div className="flex items-center gap-2.5">
      <img src={img} alt={title} className="w-6 h-6" />
      <h1 className="text-lg font-semibold text-muted-foreground">{title}</h1>
    </div>
  );
}
